var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Approved"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved",
    clipPath: "url(#clip-Approved)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9875",
    "data-name": "Group 9875",
    transform: "translate(-708.364 -228.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858",
    transform: "translate(-8902.5 -1274.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9718",
    "data-name": "Group 9718",
    transform: "translate(-9.914 -9.914)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(9621.914 1515.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19338",
    "data-name": "Path 19338",
    d: "M200.357,266.13a1.7,1.7,0,0,0-2.409,0l-7.6,7.6L188.1,270.7a1.7,1.7,0,1,0-2.409,2.408l3.446,4.241a1.7,1.7,0,0,0,2.408,0l8.809-8.809A1.7,1.7,0,0,0,200.357,266.13Z",
    transform: "translate(9448.23 1263.175)",
    fill: "#5ec3c6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_19520",
    "data-name": "Path 19520",
    transform: "translate(734.54 252.086)",
    fill: "#5ec3c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.34423828125 15.93847846984863 C 4.156758308410645 15.93847846984863 0.7499982714653015 12.53171825408936 0.7499982714653015 8.34423828125 C 0.7499982714653015 4.156758308410645 4.156758308410645 0.7499982714653015 8.34423828125 0.7499982714653015 C 12.53171825408936 0.7499982714653015 15.93847846984863 4.156758308410645 15.93847846984863 8.34423828125 C 15.93847846984863 12.53171825408936 12.53171825408936 15.93847846984863 8.34423828125 15.93847846984863 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.34423828125 1.499998092651367 C 4.570308685302734 1.499998092651367 1.499998092651367 4.570308685302734 1.499998092651367 8.34423828125 C 1.499998092651367 12.11816787719727 4.570308685302734 15.18847846984863 8.34423828125 15.18847846984863 C 12.11816787719727 15.18847846984863 15.18847846984863 12.11816787719727 15.18847846984863 8.34423828125 C 15.18847846984863 4.570308685302734 12.11816787719727 1.499998092651367 8.34423828125 1.499998092651367 M 8.34423828125 -1.9073486328125e-06 C 12.95263862609863 -1.9073486328125e-06 16.68847846984863 3.735848426818848 16.68847846984863 8.34423828125 C 16.68847846984863 12.95263862609863 12.95263862609863 16.68847846984863 8.34423828125 16.68847846984863 C 3.735848426818848 16.68847846984863 -1.9073486328125e-06 12.95263862609863 -1.9073486328125e-06 8.34423828125 C -1.9073486328125e-06 3.735848426818848 3.735848426818848 -1.9073486328125e-06 8.34423828125 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M4.5,0A4.505,4.505,0,0,0,0,4.5H4.5V9a4.5,4.5,0,0,0,0-9Z",
    transform: "translate(747.384 264.931) rotate(180)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedActive);
export default __webpack_public_path__ + "static/media/Approved_Active.3f9fb3af0ca04a73972560fa964da96d.svg";
export { ForwardRef as ReactComponent };